// extracted by mini-css-extract-plugin
module.exports = {"welcomeBox":"style__welcomeBox__DDhEc"};